/**
 * Regex to check names, with some special characters allowed
 * @type {RegExp}
 */

const names = /^(?:[\p{L}\p{Mn}\p{Pd}.,'\s]+)+$/u

export default names
